export default __webpack_public_path__ + "static/caruosel-bottom-361c19e59e1e7c6e40a221ea30af1846.jpg";